import type { ReactNode } from "react";

export const APP_LEGAL_UPDATED = "09 de outubro de 2026";

export function AppLegalLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="pb-20 pt-28">
      <article className="mx-auto max-w-[720px] px-5 text-base leading-relaxed text-muted-foreground [&_a]:text-nook-green [&_a]:underline [&_a]:underline-offset-2 [&_h2]:mt-10 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_li]:mt-2 [&_ol]:mt-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:mt-4 [&_strong]:text-foreground [&_ul]:mt-4 [&_ul]:list-disc [&_ul]:pl-6">
        <h1 className="display text-4xl text-foreground sm:text-5xl">{title}</h1>
        <p className="!mt-4 text-xs uppercase tracking-[0.16em]">
          Última atualização: {APP_LEGAL_UPDATED}
        </p>
        <div className="mt-8">{children}</div>
      </article>
    </section>
  );
}
